import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableNegativations from "./components/table/TableNegativation";


function NegativationsRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableNegativations />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default NegativationsRegisterPage